<template>
    <b-container>
        <b-row>
            <b-col cols-sm="12" cols-md="6" class="container-row">
                <div  class="authentication-card" :class="isMobile ? ' mobile-card': '' ">
                    <template v-if="!didRequestPasswordReset">
                        <div class="center-content">
                            <h3>
                                Recover password
                            </h3>
                        </div>
                        <b-form-group
                            label="Username*"
                            label-for="login-username"
                            :state="passwordResetRequest.Username.length == 0">
                            <b-form-input id="login-username" v-model="passwordResetRequest.Username" placeholder="user@email.com" :state="isValidEmail()"></b-form-input>
                            <b-form-invalid-feedback>Please enter a valid email address</b-form-invalid-feedback>
                        </b-form-group>
                        <div class="p-3"></div>
                        <div class="p-3"></div>
                        <div>
                            <b-button
                                @click="onResetPassword()"
                                variant="primary"
                                class="full-width"
                                :disabled="isLoading">
                                <template v-if="isLoading">
                                  <loading loadingText="Submitting"></loading>
                                </template>
                                <template v-else>
                                  Recover Password
                                </template>
                            </b-button>
                        </div>
                        <div class="separator"></div>
                        <div>
                            <b-button
                                href="/authentication/login"
                                variant="secondary"
                                class="full-width">
                                Cancel
                            </b-button>
                        </div>
                    </template>
                    <template v-if="didRequestPasswordReset">
                        <div class="center-content">
                            <h3>
                                We received your request
                            </h3>
                        </div>
                        <p>Please check your email inbox</p>
                        <p>We sent you a link to recover your password</p>
                        <div>
                            <b-button
                                href="/authentication/login"
                                variant="primary"
                                class="full-width">
                                Continue
                            </b-button>
                        </div>
                    </template>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>
<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import MxSecurity from '@/mixins/security'
import { IPasswordResetRequest } from '@/store/security/types'
import { TPIException } from '@/store/editor/types'
import Loading from '@/components/utility/loading.vue'
import { isMobile, handleResize } from '@/common/helpers/responsive-helper'

const emailRegex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/

@Component({
  components: {
    Loading,
  },
})

export default class extends Mixins(MxSecurity) {
  public isMobile = isMobile()
  public didRequestPasswordReset = false

  public didSubmit = false

  public isLoading = false

  public passwordResetRequest: IPasswordResetRequest = {
    Username: '',
    Challenge: '',
  }

  public created() {
    handleResize((isMobile) => {
      this.isMobile = isMobile
    })
  }

  public async onResetPassword() {
    const { passwordResetRequest } = this

    this.didSubmit = true
    this.isLoading = true

    if (!this.isFormValid) {
      this.isLoading = false
      return
    }

    await this.$recaptchaLoaded()

    passwordResetRequest.Challenge = await this.$recaptcha('signup')

    this.resetpassword({ passwordResetRequest }).then(() => {
      this.didRequestPasswordReset = true
    }).catch(({ Message } : TPIException) => {
      if (this.$refs.recaptcha) {
        (this.$refs.recaptcha as any).reset()
      }

      this.toastError(Message)
    }).finally(() => {
      this.isLoading = false
    })
  }

  public isValidEmail() {
    return !this.didSubmit
      ? null
      : emailRegex.test(this.passwordResetRequest.Username ?? '')
  }

  public onRecaptchaVerify(challenge: string) {
    this.passwordResetRequest.Challenge = challenge
  }

  private get isFormValid(): boolean {
    return (this.isValidEmail() ?? false)
  }
}
</script>
<style>
    @import '../../styles/authentication.css'
</style>
